/* eslint-disable @typescript-eslint/no-explicit-any */

export const deepCloneValueToValue = (
  obj: any,
  toValue: any,
  filterFunc?: (obj: any) => boolean
) => {
  if (filterFunc && obj !== undefined && typeof obj === 'object' && filterFunc(obj)) {
    return toValue
  }

  if (typeof obj !== 'object' || obj === null) {
    return toValue
  }

  return Object.keys(obj).reduce(
    (acc, key) => {
      acc[key] = deepCloneValueToValue(obj[key], toValue, filterFunc)
      return acc
    },
    {} as Record<string, any>
  )
}

export const arrayToKeyValueObject = (array: any[], keyValue?: any) => {
  return array.reduce((obj, item) => {
    obj[item] = keyValue
    return obj
  }, {})
}
export const getValueAsPathFromObject = <T = any>(obj: any, path: string) => {
  const depth = path.split('.')
  return depth.reduce((acc, key) => {
    return acc[key]
  }, obj) as T
}
